import { COMPANY } from "@/lib/content";

/** Company email that wraps cleanly at the "@" on narrow screens instead of mid-word. */
export const EmailText = () => {
  const [user, domain] = COMPANY.email.split("@");
  return <>{user}<wbr />@{domain}</>;
};
